import {
  Alert,
  AlertDescription,
  AlertIcon,
  Box,
  Checkbox,
  Flex,
  Spinner,
  Text,
} from "@chakra-ui/react";
import { t } from "i18next";
import { useUpdateOrganizationMutation } from "../../../../autogen/bff-api";
import { useLoggedInWithOrgContextState } from "../../../../common/auth/useLoggedInWithOrgContextState";
import { useAppDispatch } from "../../../../common/redux/hooks";
import { updateSelectedOrg } from "../../../../common/redux/reducers/authStateReducer";
import { EntraConnections } from "./EntraConnections";

export const AzureConfiguration = () => {
  const authState = useLoggedInWithOrgContextState();
  const [editOrg, { isLoading: isUpdatingOrg }] =
    useUpdateOrganizationMutation();
  const dispatch = useAppDispatch();

  return (
    <>
      <Box
        mt="5"
        width="full"
        rounded="lg"
        border="1px solid"
        borderColor="smBorder"
        overflow="hidden"
      >
        <Flex
          alignItems="center"
          gap="3"
          px="5"
          py="3"
          backgroundColor="smBackgroundSecondary"
          borderBottom="1px solid"
          borderColor="smBorder"
        >
          <Text fontWeight="semibold">{t("Sign-in")}</Text>
          <Text fontSize="sm" color="smMuted">
            {t("Applies to the whole organization")}
          </Text>
          <Flex flex="1" />
          {isUpdatingOrg && (
            <Spinner
              size="sm"
              color="teal"
              thickness="0.2rem"
              emptyColor="gray.200"
            />
          )}
        </Flex>

        <Flex px="5" py="4" flexDir="column" gap="3">
          <Checkbox
            isChecked={authState.selectedOrg.allowScimUsersOnly ?? undefined}
            onChange={(e) => {
              editOrg({
                orgId: authState.selectedOrg.id,
                editOrganizationRequest: {
                  allowScimUsersOnly: e.target.checked,
                },
              });
              dispatch(
                updateSelectedOrg({
                  ...authState.selectedOrg,
                  allowScimUsersOnly: e.target.checked,
                }),
              );
            }}
          >
            <Text fontSize="sm">
              {t(
                "Only allow users provisioned through Azure SCIM provisioning to log in",
              )}
            </Text>
          </Checkbox>

          <Checkbox
            isChecked={
              authState.selectedOrg.enforceEntraIDAuthentication ?? undefined
            }
            onChange={(e) => {
              editOrg({
                orgId: authState.selectedOrg.id,
                editOrganizationRequest: {
                  enforceEntraIDAuthentication: e.target.checked,
                },
              });
              dispatch(
                updateSelectedOrg({
                  ...authState.selectedOrg,
                  enforceEntraIDAuthentication: e.target.checked,
                }),
              );
            }}
          >
            <Text fontSize="sm">{t("Force Entra ID authentication")}</Text>
          </Checkbox>

          <Alert status="warning" variant="subtle" borderRadius="md">
            <AlertIcon />
            <AlertDescription fontSize="sm">
              {authState.selectedOrg.enforceEntraIDAuthentication
                ? t(
                    "Users who have signed up with email/password will no longer be able to log in",
                  )
                : t(
                    "If you turn on this setting, existing users who have signed up with email/password will no longer be able to log in",
                  )}
              .
            </AlertDescription>
          </Alert>
        </Flex>
      </Box>

      <EntraConnections />
    </>
  );
};
